const he = {
    nav: {
      home: "בית",
      browse: "עיון בחתונות",
      dashboard: "לוח בקרה",
      messages: "הודעות",
      profile: "פרופיל",
      login: "התחברות",
      register: "הרשמה",
      logout: "התנתקות",
      admin: "מנהל",
      faq: "שאלות נפוצות",
      about: "אודות",
      contact: "צור קשר",
      pricing: "מחירים",
      howItWorks: "איך זה עובד",
    },
    auth: {
      login: {
        title: "ברוך שובך",
        email: "אימייל",
        password: "סיסמה",
        button: "התחבר",
        noAccount: "אין לך חשבון?",
        register: "הירשם עכשיו",
      },
      register: {
        title: "צור חשבון",
        name: "שם מלא",
        email: "אימייל",
        password: "סיסמה",
        role: "אני רוצה...",
        roleHost: "לארח חתונה",
        roleGuest: "להשתתף בחתונות",
        terms: "אני מסכים לתנאים ולמדיניות הפרטיות",
        button: "הרשמה",
        hasAccount: "כבר רשום?",
        login: "התחבר עכשיו",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "טוען...",
      error: "אירעה שגיאה",
      success: "הצלחה",
      save: "שמור",
      cancel: "ביטול",
      delete: "מחק",
      edit: "ערוך",
      back: "חזור",
      next: "הבא",
      language: "שפה",
      currency: "מטבע",
      search: "חיפוש",
      filter: "סינון",
      all: "הכל",
      none: "אין",
      yes: "כן",
      no: "לא",
    },
    footer: {
      about: "אודות",
      privacy: "פרטיות",
      terms: "תנאים",
      contact: "צור קשר",
      copyright: "© 2024 WEDVAYA. כל הזכויות שמורות.",
    },
  };

export default he;
